module.exports = __webpack_public_path__ + "img/email.5a927350.svg";